var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig, setupBingAerialImagery } from "./index";
import { sceneFlyover } from "./utils/sceneFlyover";
import { DURATIONS, FOCUSES, POSITIONS } from "./utils/standardPrimitiveData";
export function spriteView1(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Sprite View 1" +
                "</h1>" +
                "<p>" +
                "The camera will be looking at a sprite object without size attenuation. It should render normally." +
                "</p>";
        yield sceneFlyover(defaultRendererConfig(container), DURATIONS, POSITIONS, FOCUSES, (renderer) => __awaiter(this, void 0, void 0, function* () {
            // Scene setup
            setupBingAerialImagery(renderer);
            // Pick-able sprite
            const sprite = yield renderer.getObjectFactory().createSprite({
                position: {
                    cartographic: {
                        longitude: 2.633667667706,
                        latitude: -0.601510430485,
                        height: 5,
                    },
                },
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/images/cross_tex.png",
                scale: { x: 1, y: 1, z: 1 },
                sizeAttenuation: false,
                pickingUserId: 4,
            });
            renderer.getWorld().addObject(sprite);
        }));
    });
}
